import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const playlist = {
  createPlaylist: lazyModuleMethod(() => import('./createPlaylist'), 'default'),
  fetchPlaylists: lazyModuleMethod(() => import('./fetchPlaylists'), 'default'),
  deletePlaylist: lazyModuleMethod(() => import('./deletePlaylist'), 'default'),
  fetchPlaylist: lazyModuleMethod(() => import('./fetchPlaylist'), 'default'),
  updatePlaylist: lazyModuleMethod(() => import('./updatePlaylist'), 'default'),
  addPlaylistArticles: lazyModuleMethod(
    () => import('./addPlaylistArticle'),
    'default'
  ),
  getArticlesBlocks: lazyModuleMethod(
    () => import('./getArticlesBlocks'),
    'default'
  ),
  changeArticleOrder: lazyModuleMethod(
    () => import('./changeArticleOrder'),
    'default'
  ),
}
